import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=126acb9e&"
import script from "./Insights.vue?vue&type=script&lang=js&"
export * from "./Insights.vue?vue&type=script&lang=js&"
import style0 from "./Insights.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Insights.vue"
export default component.exports